import { defineMessage } from 'services/localization';

export const messages = {
    companyCount1: defineMessage('unknown_text_0'),
    companyCount2_5: defineMessage('unknown_text_8'),
    companyCount6_10: defineMessage('unknown_text_9'),
    companyCount11: defineMessage('unknown_text_10'),
};
